// Vue.directive('clickoutside', {
//     bind:function(el,binding){
//       const handle = function(e){
//         if(el.contains(e.target)) {
//           return false
//         }
//         if(binding.expression){
//           binding.value(e)
//         }
//       }

//       document.addEventListener('click',handle)
//     }
//   })
// }

import Vue from "vue"
const clickoutside = {
  inserted(el, binding) {
    const handle = function(e) {
      if (el.contains(e.target)) {
        return false
      }
      if (binding.expression) {
        binding.value(e)
      }
    }

    document.addEventListener("click", handle)
  },
}

export default clickoutside
